import { render } from "./UnifiedNav.vue?vue&type=template&id=204df1a5&scoped=true"
import script from "./UnifiedNav.vue?vue&type=script&lang=js"
export * from "./UnifiedNav.vue?vue&type=script&lang=js"

import "./UnifiedNav.vue?vue&type=style&index=0&id=204df1a5&scoped=true&lang=css"

import exportComponent from "/Users/cb-it-01-1886/Documents/Chargbe Design/cb-payments-vue/cb-payments-dash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204df1a5"]])

export default __exports__